export function formatCount(value: number): string {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)}亿`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export function formatDate(value: string): string {
  return value.replace(/-/g, "/");
}

export function statusLabel(status: string): string {
  return status === "completed" ? "已完结" : "连载中";
}